import { useEffect, useState } from 'react';
import { t } from '@/lib/i18n';
import { RememberDialog } from './RememberDialog';
import type { ChatMessage, Member } from '../schemas';
import styles from './RememberPin.module.css';

interface RememberPinProps {
  member: Member;
  chatMessage: ChatMessage;
  initiallyPinned?: boolean;
}

export function RememberPin({ member, chatMessage, initiallyPinned = false }: RememberPinProps) {
  const [open, setOpen] = useState(false);
  const [pinned, setPinned] = useState(initiallyPinned);

  // Sync when the persisted state updates (e.g., memberMemories query refetches).
  useEffect(() => {
    setPinned(initiallyPinned);
  }, [initiallyPinned]);

  return (
    <>
      <button
        type="button"
        className={pinned ? `${styles.pin} ${styles.pinned}` : styles.pin}
        onClick={() => setOpen(true)}
        aria-pressed={pinned}
      >
        <BookmarkIcon filled={pinned} />
        <span>{pinned ? t('Remembered') : t('Remember')}</span>
      </button>
      <RememberDialog
        open={open}
        onOpenChange={setOpen}
        member={member}
        chatMessage={chatMessage}
        onSaved={() => setPinned(true)}
      />
    </>
  );
}

function BookmarkIcon({ filled }: { filled: boolean }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  );
}
